import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function FeaturedSection() {
  const featured = articles.filter((a) => a.featured).slice(0, 3);

  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            编辑团队精心挑选的高品质雏田同人作品，每一篇都值得细细品味
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-100 rounded-lg overflow-hidden transition-transform duration-300 hover:-translate-y-1 cursor-pointer"
              data-product-shop=""
            >
              <div className="relative w-full h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 bg-primary-500 text-background-50 dark:text-foreground-950 text-xs font-medium px-3 py-1 rounded-full whitespace-nowrap">
                  {article.categoryName}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 mb-4 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <div className="flex items-center gap-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.views.toLocaleString()}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-heart-line"></i>
                      {article.likes.toLocaleString()}
                    </span>
                  </div>
                  <span>{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}